import { render, staticRenderFns } from "./OrderRelatedSets.vue?vue&type=template&id=016ef60a&scoped=true"
import script from "./OrderRelatedSets.ts?vue&type=script&lang=ts&external"
export * from "./OrderRelatedSets.ts?vue&type=script&lang=ts&external"
import style0 from "./OrderRelatedSets.scss?vue&type=style&index=0&id=016ef60a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016ef60a",
  null
  
)

export default component.exports